import { ConfigObj } from '../utils/'

const defaultOpts = {
  tip: ''
}


export default class CustomFileInput {

  constructor($el, opts) {
    this.$el = $el;
    this.options = ConfigObj.merge(defaultOpts, opts)
  }

  /**
   * Initializes the class
   */
  init() {
    const _$input = this.$el.querySelector('input[type="file"]')
    const _$label = this.$el.querySelector('label')

    if (_$input == null || _$label == null) return console.error('Please ensure a file input and corresponding label exist')

    // Make sure the 'for' attribute is linked to the file input
    if (_$label.getAttribute('for') != _$input.id) _$label.setAttribute('for', _$input.id)

    // Given both elements are known to exist, make them available to the class instance
    this.$$input = $(_$input) // Jquery object representation of our field for jQuery validation triggering
    this.$input = _$input
    this.$label = _$label

    // Only show the tip text if the text is available
    if (this.options.tip.length) {
      this.$tip = this.createTipElement()
      this.$el.appendChild(this.$tip)
    }

    this.$fileName = this.createFileNameElement()
    this.$el.insertBefore(this.$fileName, this.$label)

    this.createFileNameElement()
    this.addEventListeners()
  }


  /**
   * Creates the file name HTMLElement to display the file name string
   * @returns {HTMLElement}
   */
  createFileNameElement() {
    const _$fileName = document.createElement('span')
    _$fileName.classList.add('ps-custom-file-input__file-name')
    return _$fileName
  }


  /**
   * Creates the tip HTMLElement to display the tip string
   * @returns {HTMLElement}
   */
  createTipElement() {
    const _$tip = document.createElement('span')
    _$tip.innerText = this.options.tip
    _$tip.classList.add('ps-custom-file-input__tip')
    return _$tip
  }


  /**
   * Actions to call when file input value cahnges
   */
  onChange(e) {
    this.$$input.valid() // Trigger jQuery validation on change
    this.displayFileName(e.target.files[0].name)
  }


  /**
   * Sets and displays the filename text
   */
  displayFileName(name) {
    this.$fileName.innerText = name
  }

  /**
   * Binds event handlers to events
   */
  addEventListeners() {
    this.$input.addEventListener('change', this.onChange.bind(this))
  }
}



// WEBPACK FOOTER //
// ./js/modules/CustomFileInput.js